<template>
  <div>
    <AppBar :hideAppBar="false" :hideUserActions="true" />
    <div class="wrapper">
      <div style="text-align: center">
        <v-btn color="primary" to="/projects/new" elevation="2">
          Create your website now <v-icon right small>mdi-auto-fix</v-icon>
        </v-btn>
      </div>
      <div
        class="elevation-2 mt-4"
        style="overflow-x: hidden; overflow: y: auto;"
      >
        <NewBlockDialogContent :demo="true" v-if="hasBlockDefs" />
      </div>
    </div>
  </div>
</template>

<script>
import NewBlockDialogContent from "../components/project/NewBlockDialogContent";
import AppBar from "../components/AppBar";
import { mapState } from "vuex";

export default {
  props: [],
  components: { AppBar, NewBlockDialogContent },
  computed: {
    ...mapState({
      hasBlockDefs: (state) => Object.keys(state.blockDefinitions).length > 0,
    }),
  },
  created() {
    document.title = "Blocks - Landly Console";
  },
};
</script>


<style lang="scss" scoped>
.wrapper {
  margin: auto;
  max-width: 1280px;
  width: 100%;
  margin-top: 60px;
}
</style>